import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-409c167c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "服务内容", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "覆盖软件开发生命周期，提供安全策略服务体系，保障信息系统稳定运行。", -1));
const _hoisted_3 = {
  class: "content-box"
};
const _hoisted_4 = {
  class: "icon-box",
  alt: "差距分析"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "差距分析", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "对客户现有开发模式、开发流程、开发管理类制度、开发类技术规范、已有安全措施等进行现状调研。", -1));
const _hoisted_7 = {
  class: "icon-box",
  alt: "成熟度评估"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "成熟度评估", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "通过一系列的指标权重来可视化地评估企业软件安全计划成熟度。", -1));
const _hoisted_10 = {
  class: "icon-box",
  alt: "体系架构设计"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "体系架构设计", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "根据现状调研信息，设计贴合企业实际情况的软件开发生命周期管控体系。", -1));
const _hoisted_13 = {
  class: "icon-box",
  alt: "管理体系设计"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "管理体系设计", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供安全开发管理办法以及体系运转支撑相关表单。", -1));
const _hoisted_16 = {
  class: "icon-box",
  alt: "技术体系设计"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "技术体系设计", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供软件开发生命周期各阶段技术规范指导文档。", -1));
const _hoisted_19 = {
  class: "bannar-box"
};
const _hoisted_20 = {
  class: "module module1"
};
const _hoisted_21 = {
  class: "icon-box",
  alt: "差距分析"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "差距分析", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "对客户现有开发模式、开发流程、开发管理类制度、开发类技术规范、已有安全措施等进行现状调研。", -1));
const _hoisted_24 = {
  class: "module module2"
};
const _hoisted_25 = {
  class: "icon-box",
  alt: "成熟度评估"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "成熟度评估", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "通过一系列的指标权重来可视化地评估企业软件安全计划成熟度", -1));
const _hoisted_28 = {
  class: "module module3"
};
const _hoisted_29 = {
  class: "icon-box",
  alt: "体系架构设计"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "体系架构设计", -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "根据现状调研信息，设计贴合企业实际情况的软件开发生命周期管控体系", -1));
const _hoisted_32 = {
  class: "module module4"
};
const _hoisted_33 = {
  class: "icon-box",
  alt: "管理体系设计"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "管理体系设计", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供安全开发管理办法以及体系运转支撑相关表单", -1));
const _hoisted_36 = {
  class: "module module5"
};
const _hoisted_37 = {
  class: "icon-box",
  alt: "技术体系设计"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "技术体系设计", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "提供软件开发生命周期各阶段技术规范指导文档", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pagination-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _directive_lazy = _resolveDirective("lazy");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'Service-Content-box active' : 'Service-Content-box')
  }, [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.moduleClass1),
    onMouseenter: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.changeM(1), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon1.png')]]), _hoisted_5, _hoisted_6], 34)), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg1.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.moduleClass2),
    onMouseenter: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.changeM(2), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon2.png')]]), _hoisted_8, _hoisted_9], 34)), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg2.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.moduleClass3),
    onMouseenter: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.changeM(3), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon3.png')]]), _hoisted_11, _hoisted_12], 34)), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg3.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.moduleClass4),
    onMouseenter: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.changeM(4), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon4.png')]]), _hoisted_14, _hoisted_15], 34)), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg4.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.moduleClass5),
    onMouseenter: _cache[4] || (_cache[4] = _withModifiers($event => _ctx.changeM(5), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon5.png')]]), _hoisted_17, _hoisted_18], 34)), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg5.png'), "background-image"]])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_swiper, {
    modules: _ctx.modules,
    "auto-height": true,
    "space-between": 16,
    "slides-perView": 'auto',
    "centered-slides": true,
    pagination: _ctx.pagination,
    autoplay: _ctx.autoplay,
    onSwiper: _ctx.onSwiper,
    onSlideChange: _ctx.onSlideChange
  }, {
    default: _withCtx(() => [_createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [_withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon1.png')]]), _hoisted_22, _hoisted_23])), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg1.png'), "background-image"]])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [_withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon2.png')]]), _hoisted_26, _hoisted_27])), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg2.png'), "background-image"]])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [_withDirectives(_createElementVNode("img", _hoisted_29, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon3.png')]]), _hoisted_30, _hoisted_31])), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg3.png'), "background-image"]])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [_withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon4.png')]]), _hoisted_34, _hoisted_35])), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg4.png'), "background-image"]])]),
      _: 1
    }), _createVNode(_component_swiper_slide, {
      class: "slide"
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [_withDirectives(_createElementVNode("img", _hoisted_37, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/consultingService_icon5.png')]]), _hoisted_38, _hoisted_39])), [[_directive_lazy, require('@/assets/img/consultingService/ceconsultingService_bg5.png'), "background-image"]])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modules", "pagination", "autoplay", "onSwiper", "onSlideChange"]), _hoisted_40])], 2)), [[_directive_lazy, require('@/assets/img/consultingService/serviceContent-bg.png'), "background-image"]]);
}